/* file description */
import React from 'react';
import { BetaSchemaForm, ProFormColumnsType } from '@cui/pro-components';
import { getBaseRecordList } from '@/api/npi.api';
import { SPForm } from '@/components/SPForm';

export const FilterQueryForm = ({ configMap, proType, onChange, span }: any) => {
  const resColumns: ProFormColumnsType<any, "text">[] = [];

  const { keyNode, checkedRecordList = [] } = configMap || {};
  const { label } = keyNode || {};
  checkedRecordList.forEach((checkedRecord: any) => {
    const { product_type, name, number, feature_type } = checkedRecord || {};
    if (!proType || (proType === product_type)) {
      resColumns.push({
        dataIndex: `${keyNode.number}_${product_type}_${number}`,
        valueType: 'select',
        title: `${name}`,
        fieldProps: {
          showSearch: true
        },
        request: async () => {
          const [_, result] = await getBaseRecordList({
            model_id: 'bd_feature_value',
            data: {
              condition: 'feature_code = ${feature_code}',
              parameters: { feature_code: number },
              pageSize: 1000,
            }
          });
          const { data = {} } = result || {};
          return (data?.data || []).map((dataItem: any) => ({
            ...dataItem,
            label: dataItem.value_name,
            value: JSON.stringify({
              label: dataItem.value_name,
              feature_code: number,
              value: dataItem.value_code,
              featureType: feature_type,
              materialClassification: keyNode.number,
            }),
          }));
        }
      });
    }
  })

  return (
    <SPForm
      style={{ width: '100%' }}
      layout="horizontal"
      rowProps={{ gutter: [0, 12] }}
      colProps={{ span: 24 }}
      labelCol={{ span: 6 }}
      submitter={false}
      columns={resColumns}
      onValuesChange={onChange}
    />
  );
  // return <BetaSchemaForm style={{ width: '100%' }} layout="horizontal" grid={true} rowProps={{ gutter: [0, 12] }} colProps={{ span: 24 }} labelCol={{ span: 6 }} submitter={false} columns={resColumns} onValuesChange={onChange} />;
};
